import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import SortButton from '../../SortButton/SortButton';
import HorizontalBar from '../HorizontalBar/HorizontalBar';
import HorizontalPlotSkeleton from '../../skeletons/HorizontalPlotSkeleton/HorizontalPlotSkeleton';
import HorizontalBarChartPlaceholder from '../../chartsPlaceholders/HorizontalBarChartPlaceholder/HorizontalBarChartPlaceholder';
import IsCountingBlock from '../../IsCountingBlock/IsCountingBlock';
import styles from './HorizontalBarChart.module.scss';

const HorizontalBarChart = ({
  title,
  style,
  data = [],
  placeholderType,
  className,
  loading = false,
  colors,
  onItemClick,
  isActiveItem,
  outlined = false,
  valueKey = 'value',
  nullContent,
}) => {
  const [items, setItems] = useState([]);
  const [sortDirection, setSortDirection] = useState('asc');

  const isCounting = useSelector((state) => state.statisticsStore.isCounting);

  const handleSortBtnClick = () => {
    if (sortDirection === 'asc') {
      setSortDirection('desc');
    } else {
      setSortDirection('asc');
    }
  };

  useEffect(() => {
    let items = data;

    if (sortDirection === 'desc') {
      items = data.slice().reverse();
    }

    setItems(items);
  }, [data, sortDirection]);

  if (loading) {
    return <HorizontalPlotSkeleton className={className} style={style} />;
  }

  if (!loading && !isCounting && data.length === 0) {
    return (
      <HorizontalBarChartPlaceholder
        type={placeholderType}
        title={title}
        className={className}
        outlined={outlined}
        style={style}
      />
    );
  }

  return (
    <div
      className={cn(className, styles.chart, { [styles.outlined]: outlined })}
      style={style}
    >
      <IsCountingBlock spinning={isCounting}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <SortButton onClick={handleSortBtnClick} />
        </div>
        <HorizontalBar
          data={items}
          barSize={8}
          colors={colors}
          onItemClick={onItemClick}
          isActiveItem={isActiveItem}
          sortDirection={sortDirection}
          valueKey={valueKey}
          nullContent={nullContent}
        />
      </IsCountingBlock>
    </div>
  );
};

export default HorizontalBarChart;
